import { withStyles } from "@material-ui/core/styles";
import MuiTableRow from "@material-ui/core/TableRow";

export const StyledTableRow = withStyles({
  root: {
    backgroundColor: "transparent !important", // to override styles being applied from healthylife website
  },
})(MuiTableRow);
